define([
    "jquery",
    "underscore",
    "marionette",
    "qrcode",
    "holdon"
], function ($, _, Marionette, QRCode) {
    return Marionette.ItemView.extend({
        template: false,
        el: "#content_layout",

        ui: {
            // Select MT Account
            'mtAccounts': '#mt4_account_no',
            // Deposit address
            'usdtWalletAddress': '#usdt_wallet_deposit_address',
            // Deposit address QR code
            'usdtWalletQR': '#usdt_wallet_qr',
            // Success/Failure
            'failureMsg': '#failure_msg',
            'failureMsgText': '#failure_msg_text',
            // Pending deposits
            'pendingDeposit': '#pending_deposit',
            // Timer
            'timer': '#timer',
            // Current rate
            'currentRate': '#current_rate',
        },

        events: {
            // User change the select MT Account
            'change @ui.mtAccounts': 'refreshDepositDatas',
            'click @ui.usdtWalletAddress': 'copyUsdtWalletAddressToClipboard'
        },

        /**
         * Fetch or generate USDT Wallet deposit address
         */
        initialize: function () {
            this.bindUIElements();
            this.refreshDepositDatas();

            // --- Update pending deposit table
            this.updating = false;
            this.seconds = 10;
            setInterval(this.checkRefreshTimer.bind(this), 1000);

            // ---- Update USDT Wallet rate
            setInterval(this.updateUsdtRate.bind(this), 60000);

            // set bootstrap4 tooltip in manual
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'manual' 
            });
        },

        /**
         * Refresh everything
         */
        refreshDepositDatas: function () {
            this.updatePendingDeposit();
            this.getDepositAddress();
        },

        /**
         * Generate or get a USDT Wallet deposit address
         */
        getDepositAddress: function () {
            var that = this;

            HoldOn.open({
                message: "Generating USDT Wallet address ...",
                theme: "sk-fading-circle"
            });

            var selectedIndex = this.ui.mtAccounts[0].selectedIndex;

            $.ajax('/rest_crypto/get_deposit_address', {
                data: {
                    crypto: 'TRON_USDT',
                    mt_account: this.ui.mtAccounts[0][selectedIndex].value,
                },

                success: function (data) {
                    that.ui.usdtWalletAddress.text(data.address);
                    QRCode.toCanvas(that.ui.usdtWalletQR[0], data.address);

                    HoldOn.close();
                    that.ui.failureMsg.hide();

                    // Update USDT rate here since HoldOn is closed
                    that.updateUsdtRate();
                },

                error: function (error) {
                    HoldOn.close();
                    that.ui.failureMsg.show();
                    that.ui.failureMsgText.text(error.responseJSON.error);

                    // Update btc rate here since HoldOn is closed
                    that.updateUsdtRate();
                }
            })
        },

        checkRefreshTimer: function () {
            this.seconds -= 1;
            if (this.seconds > 0) {
                this.ui.timer.html(' (' + this.seconds + ')');
                return;
            }

            if (this.updating === false) {
                this.ui.timer.html(' (~)');
                this.updating = true;
                this.updatePendingDeposit();
            }
        },

        updateUsdtRate: function () {
            var that = this;

            var selectedIndex = this.ui.mtAccounts[0].selectedIndex;
            var currency = this.ui.mtAccounts[0][selectedIndex].attributes.currency.value;

            $.ajax('/rest_crypto/get_crypto_rate', {
                data: {
                    crypto_currency: 'USDT',
                    currency: currency
                },

                success: function (data) {
                    let price = parseFloat(data).toFixed(3);

                    that.ui.currentRate.text('1 USDT = ' + price + ' ' + currency.toUpperCase());

                },

                error: function (error) {
                }
            })
        },

        /**
         * Update the pending deposit table
         */
        updatePendingDeposit: function () {
            var that = this;

            var selectedIndex = this.ui.mtAccounts[0].selectedIndex;

            $.ajax('/rest_crypto/get_pending_deposits', {
                data: {
                    crypto_currency: 'USDT',
                    mt_account: this.ui.mtAccounts[0][selectedIndex].value,
                },

                success: function (data) {
                    $("#pending_deposit tbody tr").remove();

                    if (data && data.length) {
                        that.updatePendingDepositTable(data);
                    }

                    that.updating = false;
                    that.seconds = 10;
                },

                error: function (error) {
                }
            })
        },

        /**
         * Populate the pending deposit table
         */
        updatePendingDepositTable: function (data) {
            var that = this;

            data.forEach(function (el) {
                var tr = $('<tr>');

                var tdTime = $('<td class="text-center">');
                var tdAmount = $('<td class="text-center">');
                var tdAmountUsd = $('<td class="text-center">');
                var tdLink = $('<td class="text-center">');

                tr.append(tdTime);
                tr.append(tdAmount);
                tr.append(tdAmountUsd);
                tr.append(tdLink);

                tdTime.html(el.reg_datetime);
                tdAmount.html(el.amount);
                tdAmountUsd.html(parseFloat(el.amount_usd).toFixed(2));
                tdLink.html('<a target="_blank" href="https://tronscan.org/#/transaction/' + el.transaction_id + '">Link</a>');

                that.ui.pendingDeposit.children('tbody').append(tr);
            });
        },

        copyUsdtWalletAddressToClipboard: function (e) {
            const that = this
            const usdtWalletAddr = this.ui.usdtWalletAddress.text()

            if(navigator.clipboard) {
                /*
                    For latest browsers or https
                */
                navigator.clipboard.writeText(usdtWalletAddr).then(() => {
                    that.ui.usdtWalletAddress.tooltip('show')
                    setTimeout(function() {
                        that.ui.usdtWalletAddress.tooltip('hide')
                    }, 1500)
                }, (err) => {})
            }
            else {
                /*
                    For old browsers or http
                    document.execCommand('copy') only supports <input> or <textarea>.
                    
                    1. generate a temp textarea
                    2. copy btc wallet address to the textarea
                    3. copy the textarea value to clipboard
                    4. remove the textarea
                */
                const tempArea = $("<textarea>")
                $('body').append(tempArea)
                tempArea.val(usdtWalletAddr).select()

                try {
                    const result = document.execCommand('copy')

                    if (result) {
                        that.ui.usdtWalletAddress.tooltip('show')
                        setTimeout(function() {
                            that.ui.usdtWalletAddress.tooltip('hide')
                        }, 1500)
                    }
                } catch (err) {}
                
                tempArea.remove()
            }
        }
    });
});
